<div class="not-found-container d-flex flex-column align-items-center justify-content-center h-100 text-center">
  <div class="fs-120 fw-bold mb-1 opacity-8">Oops!</div>
  <div class="fs-32 fw-normal opacity-9 mb-4">404 Page Not Found</div>
</div>
